module.exports = __webpack_public_path__ + "static/media/google-analytics-logo.f1654e88.png";